module.exports = __webpack_public_path__ + "static/media/qadra-background.cce1ad64.jpg";